// Konfigurace webpack
if (!__DEV__) {
    __webpack_public_path__ = `${serverContextPath}/res/`;
}
